import { AdminAppState } from '../../state';
import { UpdateEventInput } from '../../mutations';
import { getCreateEventInput } from './get-create-event-input';

export const getUpdateEventInput = (eventKey: string) => (
  state: AdminAppState,
): UpdateEventInput => {
  return getCreateEventInput(eventKey)(state);
};
